<template>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        :width="imgWidth"
        :height="imgHeight"
        :viewBox="viewBox"
    >
        <g class="svg">
            <defs>
                <rect
                    id="wrapper_path"
                    :x="imgData.x"
                    :y="imgData.y"
                    :width="imgData.raw.width"
                    :height="imgData.raw.height"
                ></rect>
            </defs>
            <clipPath id="wrapper">
                <use xlink:href="#wrapper_path" style="overflow:visible;"></use>
            </clipPath>
            <!-- 写真 -->
            <g class="photo">
                <image
                    style="overflow:visible;"
                    :width="imgData.raw.width"
                    :height="imgData.raw.height"
                    id="photo_img"
                    :xlink:href="photoUrl"
                    :transform="transform"
                ></image>
            </g>
            <!-- イラスト -->
            <g id="draw" class="draw">
                <!-- ここをアニメーション -->
                <defs>
                    <path :id="pathClass('draw_animate')" :d="path"></path>
                </defs>
                <clipPath :id="pathClass('draw_path')">
                    <use :xlink:href="pathClass('#draw_animate')" style="overflow:visible;"></use>
                </clipPath>
                <g :style="'clip-path:url(#'+pathClass('draw_path')+');'">
                    <image
                        style="overflow:visible;"
                        :width="imgData.raw.width"
                        :height="imgData.raw.height"
                        :xlink:href="paintUrl"
                        :transform="transform"
                    ></image>
                </g>
            </g>
        </g>
    </svg>
</template>
<style lang="scss" scoped>
.draw {
    clip-path: url(#wrapper);
}
</style>
<script>
// マスクパスのデータ
import path_data from "@/assets/animate/animate";
import { setInterval, clearInterval, setTimeout } from "timers";
import timerList from "@/assets/js/timer";
//const snap = require(`imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js`);

// アニメーション詰んでるので現状保留
// import MaskPath from "@/components/animate-path";

const timer = timerList.timer;
export default {
    components: {
        //MaskPath
    },
    data() {
        return {
            count: 0,
            start: false
        };
    },
    props: {
        imgData: {
            type: Object,
            required: true
        },
        // ここがtrueになったらアニメーション発火
        isPlay: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // ここがマスクのパス！
        path() {
            return path_data["path"][this.count];
        },
        viewBox() {
            return (
                this.imgData.x +
                " " +
                this.imgData.y +
                " " +
                this.imgData.raw.width +
                " " +
                this.imgData.raw.height
            );
        },
        imgWidth() {
            let userAgent = window.navigator.userAgent.toLowerCase();
            if ( userAgent.indexOf( 'msie' ) !== -1 || userAgent.indexOf( 'trident' ) !== -1 )  return this.imgData.raw.width / 3
            else return "100%"
        },
        imgHeight() {
            let userAgent = window.navigator.userAgent.toLowerCase();
            if ( userAgent.indexOf( 'msie' ) !== -1 || userAgent.indexOf( 'trident' ) !== -1 )  return this.imgData.raw.height / 3
            else return "100%"
        },
        transform() {
            return (
                "matrix(1 0 0 1 " + this.imgData.x + " " + this.imgData.y + ")"
            );
        },
        photoUrl() {
            return require("@/assets/img/photo/after/" +
                this.imgData.photo +
                ".jpg");
        },
        paintUrl() {
            return require("@/assets/img/photo/before/" +
                this.imgData.paint +
                ".png");
        },
        width() {
            return this.photo.width + "px";
        }
    },
    methods: {
        animStart() {
            this.count++;
            //console.log(this.imgData.photo + ":" + this.count);
        },
        pathClass(str) {
            return str + "_" + this.imgData.photo;
        }
    },
    mounted() {},
    watch: {
        count() {
            if (this.count > 50) {
                clearInterval(timer[this.imgData.photo]);
            }
        },
        isPlay() {
            if (!this.start) {
                setTimeout(() => {
                    timer[this.imgData.photo] = setInterval(
                        this.animStart,
                        120
                    );
                    // 検索用：現状スクロール後2秒後に写真に変化するようにしています
                    // TODO: 調整のため無効化中
                }, 500);
                this.start = true;
            }
        }
    }
};
</script>